export const updateHoldingLabel = async (api, id, label) => {
  return await api.rpcRequest("update-holding-label", {
    holdingID: id,
    label,
  });
};
